module.exports = __webpack_public_path__ + "img/ima-logo-white.02c3afaa.svg";